import React from 'react';
import Label from '~/src/atoms/Label/';
import tw from 'twin.macro';
import useSelectedPack from './useSelectedPack';
import shouldShowMrp from '~/src/libs/shouldShowMrp';

const Pricing = ({ showMrp = true, showSp = true, ...rest }) => {
  const { pricing = {}, availability = {} } = useSelectedPack();
  return (
    <div css={tw`flex items-center space-x-1 h-5`} {...rest}>
      {showSp && availability?.display_sp && pricing?.discount?.prim_price?.sp && (
        <Label css={tw`font-semibold text-base leading-sm tracking-wide text-darkOnyx-800`}>{`₹${pricing?.discount?.prim_price?.sp}`}</Label>
      )}
      {showMrp && availability.display_mrp && shouldShowMrp(pricing?.discount?.prim_price?.sp, pricing.discount.mrp) && (
        <Label css={[tw`font-regular text-sm leading-md text-darkOnyx-200`, pricing.discount.d_avail == 'true' && tw`line-through`]}>
          {`₹${pricing.discount.mrp}`}
        </Label>
      )}
    </div>
  );
};

export default Pricing;
